import { Shimmer } from '@wartek-id/shimmer'

export const CategoryListItemPreloader = () => (
  <Shimmer height="76px" width="100%" />
)
export const CategoryListPreloader = () => (
  <div className="max-w-xl space-y-4">
    {Array.from({ length: 10 })?.map((_, index) => (
      <CategoryListItemPreloader key={index} />
    ))}
  </div>
)
